import axios from 'axios'

class CaringCircleService {
  constructor() {
    this.baseUrl = '/api/v1/'
  }

  saveCaringCircleUsers(circleData) {
    return axios.post(`${this.baseUrl}dependents/add_dependent/`, circleData)
  }

  getCaringCircleUsers() {
    return axios.get(`${this.baseUrl}dependents/get_dependents/`)
  }

  updateCaringCircleUsers(data) {
    return axios.put(`${this.baseUrl}dependents/update_dependent/`, data)
  }

  deleteCaringCircleUsers(userId) {
    return axios.delete(`${this.baseUrl}dependents/delete_dependent/${userId}`)
  }
}

export const caringCircleService = new CaringCircleService()
